/**
 * @class Colorfile
 */
export default class Colorfile {
    /**
     * @param {Number}  id
     * @param {String}  name
     */
    constructor(id, name) {
        this._id = id;
        this._name = name;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Colorfile");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }
}
